import React from 'react'
import PropTypes from 'prop-types'
import TooltipComponent from '../utils/TooltipComponent'
import IconComponent from './IconComponent'
import ButtonComponent from './ButtonComponent'

const AddButtonComponent = ({ onClick, children, disabled }) => {
  return (
    <TooltipComponent content="Add" id="add-tooltip" placement="bottom">
      <ButtonComponent type="button" color="success mb-1" onClick={onClick} disabled={disabled}>
        <IconComponent icon="Add" height="18" /> &nbsp;&nbsp;{children}
      </ButtonComponent>
    </TooltipComponent>
  )
}

AddButtonComponent.propTypes = {
  onClick: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
  disabled: PropTypes.bool,
}

export default AddButtonComponent
